// Diseño de la hoja mensual del Excel "Control diario de producción", tomado del archivo
// del cliente (colores, encabezados, anchos y formatos). Lo usan la vista en pantalla y la
// descarga en Excel para que se vean igual.

export const COLORS = {
  navy: '001F41',
  blue: '2E5C8A',
  coral: 'B71D3F',
  amber: '7A4E00',
  pink: 'FC536D',
  text: '1A1C1C',
  border: 'C9CDD3',
  kpiLabel: '0F3460',
  kpiValue: 'F3F3F3',
  white: 'FFFFFF',
};

// Grupos de columnas: color del encabezado y de las celdas de datos
export const GROUPS = {
  datos: { header: COLORS.navy, fill: 'FFF9E0', font: COLORS.text },
  fechas: { header: COLORS.navy, fill: null, font: COLORS.text },
  calculos: { header: COLORS.blue, fill: 'EEF3F8', font: COLORS.navy },
  productividad: { header: COLORS.coral, fill: 'FBEFF1', font: COLORS.coral },
  conciliacion: { header: COLORS.amber, fill: 'FFF4E0', font: COLORS.amber },
};

// Formatos de número (código Excel)
export const NF = {
  date: 'dd/mm/yyyy',
  int: '#,##0',
  one: '#,##0.0',
  two: '#,##0.00',
  pct: '0.0%;\\-0.0%;0.0%',
  diff: '#,##0;\\(#,##0\\);0',
  text: '@',
  general: 'General',
};

// Columnas A…AG: encabezado (fila 8), ancho, grupo, formato en datos y en TOTAL MES
export const COLUMNS = [
  { col: 'A', header: 'Fecha', width: 11, group: 'fechas', nf: NF.date, totalNf: NF.general },
  { col: 'B', header: 'Día', width: 7, group: 'fechas', nf: NF.general, totalNf: NF.general },
  { col: 'C', header: 'N° Ciclos', width: 9, group: 'datos', nf: NF.int, totalNf: NF.int },
  { col: 'D', header: 'Kg Ciclos', width: 11, group: 'datos', nf: NF.one, totalNf: NF.one },
  { col: 'E', header: 'N° Lotes', width: 9, group: 'datos', nf: NF.int, totalNf: NF.int },
  { col: 'F', header: 'Kg Lotes', width: 11, group: 'datos', nf: NF.one, totalNf: NF.one },
  { col: 'G', header: 'Kg Alistamiento', width: 12, group: 'datos', nf: NF.one, totalNf: NF.one },
  { col: 'H', header: 'Prendas Alistadas', width: 11, group: 'datos', nf: NF.int, totalNf: NF.int },
  { col: 'I', header: 'Horas Autorizadas', width: 10, group: 'datos', nf: NF.one, totalNf: NF.one },
  { col: 'J', header: 'Responsable', width: 16, group: 'datos', nf: NF.general, align: 'left' },
  { col: 'K', header: 'Observaciones', width: 28, group: 'datos', nf: NF.general, align: 'left', wrap: true },
  { col: 'L', header: 'Kg / Ciclo', width: 9, group: 'calculos', nf: NF.one, totalNf: NF.one },
  { col: 'M', header: 'Var % Día\nFact. vs Lotes', width: 11, group: 'calculos', nf: NF.pct, totalNf: NF.pct },
  { col: 'N', header: 'Ciclos / Hora', width: 9, group: 'productividad', nf: NF.two, totalNf: NF.two },
  { col: 'O', header: 'Kg Fact. / Hora', width: 10, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'P', header: 'Kg Lotes / Hora', width: 10, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'Q', header: 'Kg Alist. / Hora', width: 10, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'R', header: 'Prendas / Hora', width: 10, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'S', header: 'Acum. Kg Ciclos', width: 11, group: 'calculos', nf: NF.one },
  { col: 'T', header: 'Acum. Kg Lotes', width: 11, group: 'calculos', nf: NF.one },
  { col: 'U', header: 'Acum. Kg Alist.', width: 11, group: 'calculos', nf: NF.one },
  { col: 'V', header: 'Acum. Prendas', width: 11, group: 'calculos', nf: NF.int },
  { col: 'W', header: 'Acum. Horas', width: 10, group: 'calculos', nf: NF.one },
  { col: 'X', header: 'Var % Acum.\nFact. vs Lotes', width: 12, group: 'calculos', nf: NF.pct, totalNf: NF.pct },
  { col: 'Y', header: 'Var % Acum.\nAlist. vs Fact.', width: 12, group: 'calculos', nf: NF.pct, totalNf: NF.pct },
  { col: 'Z', header: 'Kg Fact. / Hora\nAcum.', width: 11, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'AA', header: 'Kg Alist. / Hora\nAcum.', width: 11, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'AB', header: 'Prendas / Hora\nAcum.', width: 11, group: 'productividad', nf: NF.one, totalNf: NF.one },
  { col: 'AC', header: 'Var % Kg/h Día\nvs Acum.', width: 11, group: 'productividad', nf: NF.pct },
  { col: 'AD', header: 'Kg facturables\n(lavado × factor)', width: 12, group: 'conciliacion', nf: NF.one, totalNf: NF.one },
  { col: 'AE', header: 'Dif. Facturable\n− Alistado', width: 11, group: 'conciliacion', nf: NF.diff, totalNf: NF.diff },
  { col: 'AF', header: 'Dif. Acum.\nFact. − Alist.', width: 12, group: 'conciliacion', nf: NF.diff },
  { col: 'AG', header: 'Conciliación\nfacturación', width: 16, group: 'conciliacion', nf: NF.general, totalNf: NF.general },
];

// Fila 7: etiquetas de grupo (celda inicial y color de texto)
export const GROUP_LABELS = [
  { col: 'C', text: '◄ DATOS A DILIGENCIAR (celdas amarillas) ►', color: COLORS.pink },
  { col: 'L', text: '◄ CÁLCULOS AUTOMÁTICOS ►', color: COLORS.blue },
  { col: 'N', text: '◄ PRODUCTIVIDAD POR HORA AUTORIZADA ►', color: COLORS.coral },
  { col: 'AD', text: '◄ CONCILIACIÓN FACTURACIÓN ►', color: COLORS.amber },
];

// Filas 4–6: banda de KPIs (cada una ocupa 2 columnas; el valor 2 filas)
export const KPI_BAND = [
  { col: 'C', col2: 'D', label: 'Días registrados', key: 'diasRegistrados', nf: '0' },
  { col: 'E', col2: 'F', label: 'Kg Ciclos mes', key: 'kgCiclos', nf: NF.one },
  { col: 'G', col2: 'H', label: 'Kg Lotes mes', key: 'kgLotes', nf: NF.one },
  { col: 'I', col2: 'J', label: 'Kg Alistados mes', key: 'kgAlist', nf: NF.one },
  { col: 'K', col2: 'L', label: 'Prendas mes', key: 'prendas', nf: NF.int },
  { col: 'M', col2: 'N', label: 'Var % Fact. vs Lotes', key: 'varFactLotes', nf: NF.pct },
  { col: 'O', col2: 'P', label: 'Var % Alist. vs Fact.', key: 'varAlistFact', nf: NF.pct },
  { col: 'Q', col2: 'R', label: 'Horas autorizadas mes', key: 'horas', nf: NF.one },
  { col: 'S', col2: 'T', label: 'Kg Fact. / Hora', key: 'kgFactHora', nf: NF.one },
  { col: 'U', col2: 'V', label: 'Kg Alist. / Hora', key: 'kgAlistHora', nf: NF.one },
  { col: 'W', col2: 'X', label: 'Prendas / Hora', key: 'prendasHora', nf: NF.one },
];

// Formato condicional de la columna Conciliación (AG)
export const CONCILIACION_STYLE = {
  'BAJO ALISTADO': { fill: 'F8B7C2', font: '8A1530', bold: true },
  'SOBRE TOLERANCIA': { fill: 'FFE9A8', font: '7A5A00', bold: true },
  OK: { fill: 'DDF1E1', font: '1E5E2E', bold: false },
};
export const SUNDAY_FONT = COLORS.pink; // A:B en negrilla coral si es domingo
export const EMPTY_DAY_FILL = 'D9D9D9'; // días que no existen en el mes
export const AC_LOW_FILL = 'FDD9DF'; // Var % Kg/h día por debajo del acumulado más allá de la tolerancia
export const AC_HIGH_FILL = 'DDF1E1'; // por encima
